export const rem = (value: number | undefined, fallback: number) =>
  `${value ?? fallback}rem`;
